module.exports = __webpack_public_path__ + "img/combo buldog.aff2b80b.jpeg";